import { toQueryParams } from "helpers/url";
import { BaseService } from "services/_baseService";
import appAxios from "services/axios";

class PipelinesAdminService extends BaseService<any> {
    constructor() {
        super(`pipelines`);
    }

    initialize = async () => {
        return appAxios.get(`${this.pathWithOrg()}/initialize`);
    };
}

export default new PipelinesAdminService();
